import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedProducts from "./sections/FeaturedProducts";
import GalleryPreview from "./sections/GalleryPreview";
import UniformCollections from "./sections/UniformCollections";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <FeaturedProducts />
      <GalleryPreview />
      <UniformCollections />
      <Footer />
    </div>;
}